import * as React from 'react';
import { graphql, ScriptStrategy, useStaticQuery } from 'gatsby';
import Script from 'analytics/components/Script';

const query = graphql`
    query GrinSdkQuery {
        settings {
            grin {
                enabled
            }
        }
    }
`;

interface GrinSdkQuery {
    settings: {
        grin?: { enabled?: boolean | null } | null;
    } | null;
}

export default function GrinSdk() {
    const { settings } = useStaticQuery<GrinSdkQuery>(query);
    const enabled = settings?.grin?.enabled;

    if (!enabled) {
        return null;
    }

    return (
        <Script
            strategy={ScriptStrategy.idle}
            cookieType="marketing"
            content={`
(function () {
  try {
    if (typeof window === 'undefined') return;
    window.Grin = window.Grin || [];
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://d38xvr37kwwhcm.cloudfront.net/js/grin-sdk.js';
    var x = document.getElementsByTagName('script')[0];
    if (x && x.parentNode) {
      x.parentNode.insertBefore(s, x);
    } else {
      document.head.appendChild(s);
    }
  } catch (e) {}
})();
            `}
        />
    );
}
